import {EntityService} from '../../../service/EntityService';

export class TenantClientService extends EntityService {

  static entity = 'app/tenant-client';

}
